module.exports = __webpack_public_path__ + "img/fourtune-brands.487a0641.jpg";